import React from "react";
import PageHero from "./PageHero";
import img13 from "../../media/images/garary/035.jpg";
import {
  FaCar,
  FaParking,
  FaBed,
  FaSwimmingPool,
  FaWifi,
  FaUtensils,
  FaPrayingHands,
  FaTableTennis,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Accommodation() {
  const navigate = useNavigate();
  const services = [
    {
      title: "Pick Up & Drop",
      icon: <FaCar />,
      desc: "We make your journey easier with reliable transport to/from Entebbe Airport or central Kampala via the Entebbe Express Highway.",
    },
    {
      title: "Parking Space",
      icon: <FaParking />,
      desc: "Secure parking with ample space for guests and event visitors. 24/7 security for peace of mind.",
    },
    {
      title: "Accommodation",
      icon: <FaBed />,
      desc: "Comfortable, well-furnished rooms designed for rest and reflection with serene hilltop views of Lake Victoria.",
    },
    {
      title: "Swimming Pool",
      icon: <FaSwimmingPool />,
      desc: "Cool off, swim laps, or relax by our poolside in a peaceful environment.",
    },
    {
      title: "Fibre Internet",
      icon: <FaWifi />,
      desc: "Enjoy free high-speed Wi-Fi across the resort to keep you connected at all times.",
    },
    {
      title: "Dining",
      icon: <FaUtensils />,
      desc: "Delicious meals blending local and international flavors, prepared with fresh ingredients.",
    },
    {
      title: "Spiritual Retreats",
      icon: <FaPrayingHands />,
      desc: "Join our overnight prayer sessions, fasting programs, and Bible study retreats for spiritual growth.",
    },
    {
      title: "Tennis Court",
      icon: <FaTableTennis />,
      desc: "Enjoy exciting tennis matches and outdoor recreation on our well-maintained tennis court, perfect for both beginners and experienced players.",
    },
  ];

  return (
    <>
      {/* HERO */}
      <PageHero
        title="Our Services"
        subtitle="Experience comfort, convenience, and spiritual growth"
        image={img13}
      />

      {/* INTRO */}
      <div className="container py-5 text-center" >
        <h2 data-aos="fade-up">Everything You Need in One Place</h2>
        <p data-aos="fade-up" className="mt-3">
          At Father’s House Church Resort Hotel, we provide a complete
          experience combining relaxation, comfort, and spiritual growth.
        </p>
      </div>

      {/* SERVICES GRID */}
      <div className="container pb-5">
        <div className="row">
          {services.map((service, index) => (
            <div
              className="col-md-4 mb-4"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="card shadow h-100 text-center p-4">
                <div
                  className="text-success mb-3"
                  style={{ fontSize: "40px" }}
                >
                  {service.icon}
                </div>

                <h5>{service.title}</h5>
                <p>{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* HIGHLIGHT SECTION */}
      <div className="container py-5">
        <div className="row align-items-center">
          
          <div className="col-md-6 mb-4" data-aos="fade-right">
            <img
              src={img13}
              alt="Resort"
              className="img-fluid rounded shadow"
            />
          </div>

          <div className="col-md-6" data-aos="zoom-in">
            <h2>A Place of Peace & Comfort</h2>
            <p className="mt-3">
              Whether you are here for relaxation, events, or spiritual
              retreats, our resort offers a peaceful environment designed to
              refresh your mind, body, and spirit.
            </p>

            <ul>
              <li>Serene natural environment</li>
              <li>Lake Victoria views</li>
              <li>Perfect for retreats & conferences</li>
            </ul>

            <button className="btn btn-success mt-3"
            onClick={() => navigate("/about")}
            >
              Explore More
            </button>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div
        className="text-white text-center py-5"
        style={{
          backgroundImage: `url(${img13})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div style={{ background: "rgba(0,0,0,0.6)", padding: "40px" }}>
          <h2 data-aos="fade-up">Ready to Experience It All?</h2>
          <p data-aos="fade-up" className="mt-2">
            Book your stay or plan your visit today.
          </p>
          <button className="btn btn-success mt-3"
          onClick={() => navigate("/rooms")}
          >
            Get Started
          </button>
        </div>
      </div>
      
    </>
  );
}

export default Accommodation;